import React, { Autocomplete, Grid, Paper, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { StatisticsService } from 'services';
import { BarChart, PieChart } from '@mui/x-charts';
import { getWeek } from 'date-fns';
import { useQuery } from '@tanstack/react-query';
import { ErrorHandler, Loader } from 'components';

export const WeekReporting = () => {
	const weeks = Array.from(Array(52).keys()).map(week => ({ number: week + 1, name: `Week ${week + 1}` }));
	const [selectedWeek, setSelectedWeek] = useState(getWeek(new Date()));
	const { data, isFetching, isLoading, error } = useQuery({ queryKey: ['weekly-statistics', selectedWeek], queryFn: async () => await StatisticsService.getWeeklyStatistics(selectedWeek) });
	return (
		<>
			<Loader active={(isFetching || isLoading)} />
			<ErrorHandler message={error?.message} />
			<Grid container component={Paper} p={1}>
				<Grid item xs={12} pb={3}>
					{weeks && weeks.length > 0 && (
						<>
							<Autocomplete
								options={weeks}
								getOptionLabel={option => option.name}
								value={weeks.find(week => week.number === selectedWeek) ?? null}
								onChange={(_, value) => setSelectedWeek(value?.number || 0)}
								renderInput={params => <TextField {...params} label='Week' size='small' />}
							/>
						</>
					)}
				</Grid>
				{data && (
					<>
						<Grid item xs={12}>
							{data.products && data.products.length > 0 && data.sales && data.sales.length > 0 && (
								<BarChart series={[{ data: data.sales }]} height={400} xAxis={[{ data: [...data.products], scaleType: 'band' }]} />
							)}
						</Grid>
						<Grid item xs={6}>
							<Typography variant='h6'>BP Points: {data.bpPoints + data.leftBPPoints + data.rightBPPoints} </Typography>
						</Grid>
						<Grid item xs={6}>
							<Typography variant='h6'>PP Points: {data.ppPoints}</Typography>
						</Grid>
						<Grid item xs={12}>
							<Grid container padding={2}>
								<PieChart
									series={[
										{
											data: [
												{ id: 0, value: data.leftBPPoints, label: 'Left BP Points' },
												{ id: 1, value: data.rightBPPoints, label: 'Right BP Points' },
											],
										},
									]}
									height={200}
								/>
							</Grid>
						</Grid>
					</>
				)}
			</Grid>
		</>
	);
};